import React from 'react';
import propTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import Player from '../Player';
import Sponsor from '../Sponsor';
import Advert from '../Advert';
import Screen from '../Screen';
import Goal from '../Goal';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
	},
	goals: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		height: '25vh',
		alignItems: 'flex-end',
		justifyContent: 'space-between',
	},
	goal: {
		height: '15vh',
	},
	player: {
		height: '5vh',
		margin: 'auto',
		marginTop: theme.spacing(1),
	},
	sponsor: {
		height: '100%',
		flex: '30vh 0 0',
	},
	main: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		height: '65vh',
		alignItems: 'space-around',
		justifyContent: 'center',
	},
	bannerAd: {
		flex: '10% 0 0',
		height: '100%',
	},
	screenBox: {
		display: 'flex',
		flexDirection: 'column',
		flex: '100% 1 1',
	},
	screen: {
		flex: '100% 0 1',
		height: '100%',
		margin: 1,
	},
}));

export default function Board1up(props) {
	const { className, board } = props;
	const classes = useStyles();

	return (
		<div className={clsx(classes.root, className)}>
			<div className={classes.main}>
				<Advert className={classes.bannerAd} type="lw1x4" />
				<div className={classes.screenBox}>
					<Screen className={classes.screen} ratio={board.screen0 || '16x9'} />
					{board.player0 && (<Player className={classes.player} pid={board.player0} />)}
				</div>
				<div className={classes.screenBox}>
					<Screen className={classes.screen} ratio={board.screen1 || '16x9'} />
					{board.player1 && (<Player className={classes.player} pid={board.player1} />)}
				</div>
				<Advert className={classes.bannerAd} type="el1x4" />
			</div>
			<div className={classes.goals}>
				<Goal className={classes.goal} />
				<Sponsor className={classes.sponsor} />
			</div>
		</div>
	);
}

Board1up.defaultProps = {
	className: undefined,
};

Board1up.propTypes = {
	className: propTypes.string,
	board: propTypes.object.isRequired,
};
